import styled, { css } from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

// shake


export const ListStyled = styled.div`
`;

const BubblesWrapper = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 10px auto 50px;
`;

const ListProperties = css`
  margin: 10px auto 50px;
  text-align: center;
`;

export const PrintUsers = styled.div`
`;


export const BubbleWrapper = styled.div`
  background-color: ${props => (props.selected ? 'rgba(51, 51, 51, 0.51)' : 'rgba(255, 255, 255, 0.6)')};
  border-radius: 50%;
  width: calc((((90vw - 2em) / 3)) - 25px);
  height: calc((((90vw - 2em) / 3)) - 25px);
  line-height: 18px;;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  margin: 0px 0px 13px 13px;
  font-size: min(16px, 10px + (12 - 10) * ((100vw - 320px) / (412 - 320)));
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: ${props => (props.selected ? '0px 0px 0px 6px rgba(255,255,255,0.6)' : 'none')};
  max-width: 15rem;
  max-height: 15rem;
  cursor: pointer;
  line-height: 15rem;
  display: inline-block;
  div {
    margin: auto;
    width: 100%;
    word-break: break-word;
    color: ${props => (props.selected ? '#fff' : props.color)};
  }
`;

export const Searcher = styled.div`
  background-color: transparent;
  width: 52.8rem;
  height: 5vh;
  margin-bottom: 2%;
  margin-left: 12.8rem;

  input {
    width: 52.8rem;
    height: 5vh;
    border-radius: 5px !important;
    border: 2px solid white;
    color: #000000;
    font-family: 'helvetica neue light';
    font-size: 18px;
    outline: none;
  }

  @media (max-width: ${TABLET_WIDTH}px){
    width: 30rem;
    height: 5vh;
    margin-bottom: 2%;
    margin-left: 25px;

    input {
      width: 30rem;
      height: 5vh;
      border-radius: 5px !important;
      border: 2px solid white;
      color: #000000;
      font-family: 'helvetica neue light';
      font-size: 18px;
      outline: none;
    }
  }
`;

export const ListItemWrapper = styled.div`
  text-align: left;
`;

export const ListItem = styled.div`
  background-color: ${props => (props.selected ? '#ffffff' : 'transparent')};
  color: ${props => (props.selected ? props.color : '#ffffff')};
  font-family: 'helvetica neue light';
  font-size: 18px;
  text-align: left;
  width: ${props => (props.isSdg ? '30%' : '')};
  ${props => (props.isSdg ? 'max-width: 129px;' : '')}
  margin-left: 5px;
  margin-bottom: 5px;
  padding: ${props => (props.isSdg ? '0px' : '8px')};
  border: 1px solid #fff;
  border-radius: 5px;
  display: inline-block;
  text-align: left;
  transition: all 0.2s ease;
  cursor: pointer;
`;

export const ListWrapper = styled.div`
  width: 90%;
  ${props => (props.view === 'bubbles' ? BubblesWrapper : ListProperties)}
`;

export const TagsWrapper = styled.div`
  text-align: left;
  padding: 0px 20px;
`;

export const TagLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  background-color: #fff;
  font-size: 12px;
  padding: 5px;
  color: #4d4d4d;
  border-radius: 5px;
  margin-top: 1rem;
`;
export const Icon = styled.div`
  height: 100%;
  width: 100%;
  border: ${props => (props.selected ? '2px solid #fff' : 'none')};
  max-width: 129px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  opacity: ${props => (props.selected ? '1' : '0.3')};
`;

export const CreatorMargin = styled.div`
  height: 150px;
`;



// WEBPACK FOOTER //
// ./src/components/Steps/List/components/styles.js